import React, { useState,useEffect } from "react";
import { Link,useNavigate,useParams } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";
import SelectDateOnly from "../components/popups/SelectDateOnly";

import { ChangeDateString,isNull,ChangeDateStringOnlyDate,ChangeDateFormat,isObjEmpty,ToggleDarkBackground,remainDays } from "../../components/common/Common";
import centerIcon from "../../img/icon/icon-center-class-03.svg";
import "../../css/style.css";

//클래스 추가/편딥
const ReinForceDetail = () => {
  let { cl_idx } = useParams();
  const branch_idx = Number(localStorage.getItem('branch_idx'));

  const navigate = useNavigate();
  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  const [varModeClass,setModeClass] = useState('');
  const [varClassInfo,setClassInfo] = useState({});
  const [varClassStudyList,setClassStudyList] = useState([]);
  const [varSemesterList,setSemesterList] = useState([]);
  const [varClassroomList,setClassroomList] = useState([]);
  const [varSelectClassroomList,setSelectClassroomList] = useState([]);
  const [varHourList,setHourList] = useState([]);
  const [varMinuteList,setMinuteList] = useState([]);
  
  const [varEditMode,setEditMode] = useState(true);

  const GetInformationForClass = async() => {
    const sendData = {branch_idx:branch_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_information_for_class`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setSemesterList(datas.semesters);   //학기목록
        setClassroomList(datas.classrooms); //교실목록

        //마마몽뗴 교실목록 추출 -- 초기값으로
        const selList = datas.classrooms.filter(el=>el.cr_type===1); 
        setSelectClassroomList(selList);

        //편집모드이면
        if(Number(cl_idx) > 0) GetClassInformation(cl_idx);
      }
    });
  }

  //클래스정보호출 - 편집모드
  const GetClassInformation = async(cl_idx) => {
    const sendData = {cl_idx:cl_idx};
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_class_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {  
        const classInfo = datas.classes[0];
        setClassInfo(classInfo);
        setClassStudyList(datas.classstudys);

        //첫수업이 이미 진행되었으면
        if(remainDays(datas.classstudys[0].cs_date) <= 0) {
          alert('이미 해당클래스는 수업이 진행되고 있으므로 수업내용을 변경할 수 없습니다.');
          setEditMode(false);
        }
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});

    //작업모드 
    let sm_idx = 0;
    if(Number(cl_idx) > 0){
      setModeClass('disable-only');
    } else {
      //현재 사용중인 학기가 존재하면
      if(!isNull(localStorage.getItem('semesterIndex'))) {
        sm_idx = Number(localStorage.getItem('semesterIndex'));
      }
    }

    //등록모드
    const newData = {cl_idx:Number(cl_idx),bh_idx:branch_idx,cl_mode:2,cl_type:1,cl_fly_mode:1,ry_idx:0,cl_name:"",vt_idx:0,vts_idx:0,
                    cr_idx:0,cl_hour:0,cl_minute:0,sm_idx:sm_idx,cl_childrens:0,cl_studys:0,sm_sdate:null,sm_edate:null};
    setClassInfo(newData);

    //시간분 배열 작성
    setHourList([0,10,11,12,13,14,15,16,17,18]);
    setMinuteList([0,30]);

    //서버로부터 정보 호출
    GetInformationForClass();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //교실 목록 변경
  useEffect(() => {
    const SelList = varClassroomList.filter(el=>el.cr_type===varClassInfo.cl_type); 
    setSelectClassroomList(SelList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varClassInfo.cl_type]);

  //정보입력부
  const onChangeInputHandler = (e) => {
    const { name, value } = e.currentTarget;
    if(name === "cl_type") {  //마마몽떼/플라이
      const imode = Number(value);
      console.log(imode);
      setClassInfo({...varClassInfo,[name]:imode});

    } else if(name === "sm_idx") {
      const sm_idx = Number(value);
      const selectInfo = varSemesterList.find(el=>el.sm_idx===sm_idx);
      const sdate = ChangeDateString(selectInfo.sm_sdate);
      const edate = ChangeDateString(selectInfo.sm_edate);
      setClassInfo({...varClassInfo,sm_idx:sm_idx,sm_sdate:sdate,sm_edate:edate});

    } else if(name === "cl_studys") {
      if(varClassInfo.cl_hour === 0) {
        alert('수업시간을 먼저 선택해주세요.'); return false;
      }
      const studys = Number(value);
      let baseData = {cs_index:0,cs_date:null,cs_hour:varClassInfo.cl_hour,cs_minute:varClassInfo.cl_minute};

      let newList = [];
      for(var j=0; j < studys; j++) {
        let inum = j+1;
        let newData = {...baseData};
        newData.cs_index = inum;
        newList.push(newData);
      }
      setClassStudyList(newList);
      console.log(newList);
      setClassInfo({...varClassInfo,[name]:Number(value)});

    } else if(name === "cl_hour" || name === "cl_minute" || name === "cl_childrens" || name === "cr_idx") {
      setClassInfo({...varClassInfo,[name]:Number(value)});
    } else {
      setClassInfo({...varClassInfo,[name]:value});
    }
  }

  //수정모드로 변경
  const onEditClassesHandler = (e) => {
    const diableBoxes = document.querySelectorAll(".disable-only");
    const showBoxes = document.querySelectorAll(".show-only");
    const hideBox = document.querySelector('.hide-only');
    const buttonNumBox = document.querySelector('.btn-no');
    for(var i1=0; i1 < diableBoxes.length; i1++) {
      diableBoxes[i1].classList.remove('disable-only');
    }
    for(var i2=0; i2 < showBoxes.length; i2++) {
      showBoxes[i2].classList.add('hide-only');
    }
    hideBox.classList.remove('hide-only');
    buttonNumBox.setAttribute('style','width:48%');
  }

  //삭제
  const onDeleteClassesHandler = async(e) => {
    const sendData = {cl_idx:cl_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_delete_classes`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        navigate('/Branch/ReinForceSet');
      } else {
        alert(datas.message);
      }
    });
  }

  //클래스등록-------------------------------------------------------------------------------------
  const onUpdateClassesHandler = async(e) => {
    if(isNull(varClassInfo.cl_name)) {
      alert('클래스명을 먼저 입력하세요.'); return false;
    } else if(varClassInfo.cr_idx === 0) {
      alert('교실을 먼저 선택하세요.'); return false;
    } else if(varClassInfo.cl_hour=== 0) {
      alert('수업시간을 먼저 선택하세요.'); return false;
    } else if(isNull(varClassInfo.cl_childrens) || varClassInfo.cl_childrens === 0) {
      alert('수업정원을 먼저 입력하세요.'); return false;
    } else if(varClassInfo.sm_idx === 0) {
      alert('학기를 먼저 선택하세요.'); return false;
    } else if(varClassInfo.cl_studys === 0) {
      alert('수업차수를 먼저 선택하세요.'); return false;
    } else if(varClassInfo.cl_studys !== varClassStudyList.length) {
      alert('입력된 수업차수와 차수별 수업일정이 일치하지 않습니다.'); return false;
    }

    for(var i=0; i<varClassStudyList.length; i++) {
      let studys = varClassStudyList[i];
      if(isNull(studys.cs_date)) {
        alert(`${i+1}차 수업의 일정을 먼저 선택하세요.`); return false;
      } else if(isNull(studys.cs_hour) || studys.cs_hour === 0) {
        alert(`${i+1}차 수업의 수업시간을 먼저 선택하세요.`); return false;
      } else if(isNull(studys.cs_minute)) {
        alert(`${i+1}차 수업의 수업분을 먼저 선택하세요.`); return false;
      }
    }

    if(!window.confirm('입력한 보강수업 클래스를 등록하시겠습니까?')) return false;

    const sendData = {cl_idx:cl_idx,branch_idx:branch_idx,dataInfo:varClassInfo};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_update_classes`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const new_cl_idx = datas.cl_idx;
        //클래스 수업차수 저장
        MakeClassStudys(new_cl_idx);
      } else {
        alert(datas.message);
      }
    });
  }
  //클래스 수업차수 저장
  const MakeClassStudys = async(new_cl_idx) => {
    const sendData = {cl_idx:new_cl_idx,dataList:varClassStudyList};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_update_classes_studys`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        navigate('/Branch/ReinForceSet');
      } else {
        alert(datas.message);
      }
    });
  }

  //날짜선택 팝업창--------------------------------------------------------------------------------------
  const [varPopupDaySelect,setPopupDaySelect] = useState(false);  //팝업창 열기/닫기
  const [varDate,setDate] = useState(null); //선택된 날짜
  const [varStudyIndex,setStudyIndex] = useState(-1); 
  const onChangeDateHandler = (e,iindex) => {
    setStudyIndex(iindex);
    const csdate = varClassStudyList[iindex].cs_date;
    const sdate = new Date(csdate);
    setDate(sdate);

    //팝업창 위치조정
    /* const hasbtns = document.querySelectorAll('.has-btn');
    const toppos = hasbtns[iindex];
    const offsetY = window.pageYOffset+toppos.getBoundingClientRect().top - 100;
    const popupWin = document.querySelector('.layer-pop-select-date');
    popupWin.setAttribute('style',`top:${offsetY}px`); */
    //팝업창 호출
    TogglePopupDaySelect(true);
  }

  const TogglePopupDaySelect = (bmode) => {
    setPopupDaySelect(bmode);
    ToggleDarkBackground(bmode);
  }

  //팝업창 - 날짜 설정값 저장
  const ChangedDate = (date,iindex) => {
    if(date === "" ) date = null;
    //console.log(date,iindex);
    const ndate = ChangeDateFormat(date);
    const copyList = [...varClassStudyList];
    const copyData = copyList[iindex];
    copyData.cs_date = ndate;
    copyList[iindex] = copyData;
    setClassStudyList(copyList);
    TogglePopupDaySelect(false);
  }

  //팝업창 - 정보입력부
  const onChangeInputArrayHandler = (e,iindex) => {
    const { name, value } = e.currentTarget;
    const copyList = [...varClassStudyList];
    copyList[iindex][name] = Number(value);
    setClassStudyList(copyList);
  }

  return isObjEmpty(varClassInfo)?null:(
    <div className="vh-content">
      <HeaderBranchTitle varPageTitle={Number(cl_idx)===0?'보강 수업 등록':'보강 수업 상세'} varBackString={'/Branch/ReinForceSet'}/>
      <div className="vh-content-body">
        {/* 클래스명 */}
        <div className="setting-form-wrap st02">
          <div className="form-group mb15">
            <label className="form-label">클래스명</label>
            <div className="field-group">
              <input type="text" name="cl_name" placeholder="클래스명을 입력하세요." value={varClassInfo.cl_name||""} className={`form-control ${varModeClass}`} onChange={e=>onChangeInputHandler(e)}/>
            </div>
          </div>
          {/* 마마몽떼/플라이 */}
          <div className="form-group mb15">
            <label className="form-label">수업</label>
            <div className="field-group flex">
              <div className="radio-group" style={{width:"40%"}}>
                <input type="radio" value={1} name="cl_type" id="type01" className={`input-radio ${varModeClass}`} style={{width:"30px"}} checked={varClassInfo.cl_type===1} onChange={e=>onChangeInputHandler(e)}/>
                <label htmlFor="type01" className={`radio-label ${varModeClass}`}>마마몽떼</label>
              </div>
              <div className="radio-group" style={{width:"40%"}}>
                <input type="radio" value={2} name="cl_type" id="type02" className={`input-radio ${varModeClass}`} style={{width:"30px"}} checked={varClassInfo.cl_type===2} onChange={e=>onChangeInputHandler(e)}/>
                <label htmlFor="type02" className={`radio-label ${varModeClass}`}>플라이</label>
              </div>
            </div>
          </div>	

          <div className="form-group mb15">
            <label className="form-label">교실명</label>
            <div className="field-group">
              <select name="cr_idx" className={`field-select ${varModeClass}`} value={varClassInfo.cr_idx} onChange={e=>onChangeInputHandler(e)}>
                <option value={0}>교실선택</option>
                {varSelectClassroomList.map((classroom,i)=>(
                  <option key={'classroom_'+i} value={classroom.cr_idx}>{varClassInfo.cl_type===1?"마마몽떼":"플라이"} {classroom.cr_name}</option>
                ))}
              </select>
            </div>
          </div>
						
          <div className="form-group mb15">
            <label className="form-label">수업시간</label>
            <div className="field-group flex">
              <select name="cl_hour" value={varClassInfo.cl_hour} className={`field-select ${varModeClass}`} style={{width:"48%"}} onChange={e=>onChangeInputHandler(e)}>
                {varHourList.map((hours,i)=>(
                  <option key={'hours_'+i} value={hours}>{hours}</option>
                ))}
              </select>
              <select name="cl_minute" value={varClassInfo.cl_minute} className={`field-select ${varModeClass}`} style={{width:"48%"}} onChange={e=>onChangeInputHandler(e)}>
                {varMinuteList.map((minutes,j)=>(
                  <option key={'minutes_'+j} value={minutes}>{minutes}</option>
                ))}
              </select>							
            </div>
          </div>

          <div className="form-group mb15">
            <label className="form-label">정원</label>
            <div className="field-group">
              <input type="text" name="cl_childrens" placeholder="정원수를 입력하세요." value={varClassInfo.cl_childrens||""} className={`form-control ${varModeClass}`} onChange={e=>onChangeInputHandler(e)}/>
            </div>
          </div>

          <div className="form-group mb15">
            <label className="form-label">학기명</label>
            <div className="field-group">
              <select name="sm_idx" className={`field-select ${varModeClass}`} value={varClassInfo.sm_idx} onChange={e=>onChangeInputHandler(e)}>
                <option value={0}>학기선택</option>
                {varSemesterList.map((semesters,i)=>(
                  <option key={'semesters_'+i} value={semesters.sm_idx}>{semesters.sm_name}</option>
                ))}
              </select>
            </div>
          </div>
          <div className="class-date">
            <div>개강일 : {ChangeDateStringOnlyDate(varClassInfo.sm_sdate)}</div>
            <div>종강일 : {ChangeDateStringOnlyDate(varClassInfo.sm_edate)}</div>
          </div>

          <div className="form-group mb25">
            <label className="form-label">수업수</label>
            <div className="field-group">
              <select name="cl_studys" value={varClassInfo.cl_studys} className={`field-select ${varModeClass}`} onChange={e=>onChangeInputHandler(e)}>
                <option value={0}>수업수를 선택</option>
                <option value={1}>1차수</option>
                <option value={2}>2차수</option>
              </select>
            </div>
          </div>

          {/* 차수별 수업일자및 시간 */}
          {varClassStudyList.map((studys,i) => (
            <div className="form-group mb15" key={'study_'+i}>
              <label className="form-label">{i+1}차 수업</label>
              <div className="field-group flex">
                <div className="has-btn" style={{width:"45%"}}>
                  <input type="text" value={ChangeDateStringOnlyDate(studys.cs_date)||""} name="cs_date" className="input-cal" disabled/>
                  <button className={`cal-btn ${varModeClass}`} onClick={e=>onChangeDateHandler(e,i)}><img src={centerIcon} alt=""/></button>
                </div>
                <select name="cs_hour" style={{width:"25%"}} className={`field-select ${varModeClass}`} value={studys.cs_hour} onChange={e=>onChangeInputArrayHandler(e,i)}>
                  {varHourList.map((hours,k)=>(
                    <option key={'hours_'+k} value={hours}>{hours}</option>
                  ))}
                </select>
                <select name="cs_minute" style={{width:"25%"}} className={`field-select ${varModeClass}`} value={studys.cs_minute} onChange={e=>onChangeInputArrayHandler(e,i)}>
                  {varMinuteList.map((minutes,j)=>(
                    <option key={'minutes_'+j} value={minutes}>{minutes}</option>
                  ))}
                </select>
              </div>
            </div>
          ))}

          <div className="form-contoller bt-btn">
            <Link to={'/Branch/ReinForceSet'} className="form-contoller-btn btn-no" style={Number(cl_idx)===0?{width:"48%"}:!varEditMode?{width:"100%"}:{}}>취소</Link>
            {!varEditMode?null:
              <>
                <button className={Number(cl_idx)===0?"form-contoller-btn btn-yes hide-only":"form-contoller-btn btn-yes show-only"} onClick={e=>onEditClassesHandler(e)}>수정</button>
                <button className={Number(cl_idx)===0?"form-contoller-btn btn-del hide-only":"form-contoller-btn btn-yes show-only"} onClick={e=>onDeleteClassesHandler(e)}>삭제</button>
                <button className={Number(cl_idx)===0?"form-contoller-btn btn-yes":"form-contoller-btn btn-yes hide-only"} onClick={e=>onUpdateClassesHandler(e)} style={{marginRight:"0"}}>확인</button>
              </>
            }
          </div>
        </div>
      </div>
      <SelectDateOnly varStudyIndex={varStudyIndex} varDate={varDate} setDate={setDate} varPopupDaySelect={varPopupDaySelect} 
                        TogglePopupDaySelect={TogglePopupDaySelect} ChangedDate={ChangedDate}/>
    </div>	
  );
}
export default ReinForceDetail;